import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { projectsAPI } from '../api';
import SEO from '../components/SEO';
import MarkdownContent from '../components/MarkdownContent';

function ProjectLegalPage({ docType }) {
  const { slug } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const isPrivacy = docType === 'privacy';
  const title = isPrivacy ? 'Privacy Policy' : 'Terms of Use';
  const contentField = isPrivacy ? 'privacy_policy' : 'terms_of_use';
  const backPath = `/p/${slug}`;

  useEffect(() => {
    loadProject();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  const loadProject = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await projectsAPI.getBySlug(slug);
      if (response.data.success) {
        const proj = response.data.project;
        if (!proj[contentField] || !proj[contentField].trim()) {
          setError(`${title} not available for this project.`);
        }
        setProject(proj);
      } else {
        setError('Project not found');
      }
    } catch (err) {
      console.error('Error loading project:', err);
      setError('Project not found');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="public-project-page">
        <div className="container">
          <div className="loading">
            <div className="spinner"></div>
            <p>Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error || !project) {
    return (
      <div className="public-project-page">
        <div className="container">
          <div className="error-state">
            <h2>{error || 'Project Not Found'}</h2>
            <Link to="/browse" className="btn btn-primary mt-3">
              Browse Projects
            </Link>
          </div>
        </div>
      </div>
    );
  }

  const content = project[contentField] || '';
  const pageTitle = `${title} - ${project.title}`;
  const pageDescription = `Read the ${title.toLowerCase()} for ${project.title} on SharePanda.`;

  return (
    <>
      <SEO
        title={pageTitle}
        description={pageDescription}
        url={`https://sharepanda.org/p/${slug}/${isPrivacy ? 'privacy' : 'terms'}`}
        type="article"
      />
      <div className="public-project-page">
        <div className="container">
          <div className="card">
            <div className="mb-3">
              <Link to={backPath} className="back-link">
                ← Back to {project.title}
              </Link>
            </div>
            <h1 className="mb-3">{title}</h1>
            <p className="text-muted mb-3">
              For the project <strong>{project.title}</strong> by{' '}
              <strong>{project.owner}</strong>.
            </p>
            {content ? (
              <div className="legal-content">
                <MarkdownContent content={content} />
              </div>
            ) : (
              <p className="text-muted">{title} content is not available.</p>
            )}
            <div className="mt-3">
              <Link to={backPath} className="btn btn-secondary">
                Back to Project
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProjectLegalPage;
